import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { JsspSettings } from './jssp-settings'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { JsspSettingsCommand } from './jssp-settings.command'

@Injectable({
  providedIn: 'root',
})
export class JsspSettingsService extends RestClientPaged<JsspSettings, string> {
  constructor() {
    const httpClient = inject(HttpClient)

    super(`${environment.apiPath}/jssp-settings`, httpClient)
  }

  public sendCommand(cmd: JsspSettingsCommand): Observable<unknown> {
    return this.http.post(`${this.restEndpoint}/command`, cmd)
  }
}
